/*
  Sticks to the top of the list while its group is on screen, then gets pushed
  out by the next group's divider — which only works because each divider sits
  inside the section holding its own rows. top-0 because the list scrolls in its
  own container below the head, rather than sharing a scrollport with it.

  Hidden from assistive tech: the surrounding group is already labelled with the
  same text, and announcing both reads it twice.
*/
const DateGroupDivider = ({ label }) => (
  <div
    aria-hidden="true"
    className="sticky top-0 z-10 flex py-1.5 bg-white/95 backdrop-blur-sm"
  >
    <span className="mx-auto px-2.5 py-0.5 rounded-full bg-gray-100 text-[10px] font-semibold uppercase tracking-wider text-gray-500">
      {label}
    </span>
  </div>
)

export default DateGroupDivider
